import { render, staticRenderFns } from "./UnionNode.vue?vue&type=template&id=0507b262&scoped=true"
import script from "./UnionNode.vue?vue&type=script&lang=js"
export * from "./UnionNode.vue?vue&type=script&lang=js"
import style0 from "./UnionNode.vue?vue&type=style&index=0&id=0507b262&scoped=true&lang=css"
import style1 from "./UnionNode.vue?vue&type=style&index=1&id=0507b262&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507b262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0507b262')) {
      api.createRecord('0507b262', component.options)
    } else {
      api.reload('0507b262', component.options)
    }
    module.hot.accept("./UnionNode.vue?vue&type=template&id=0507b262&scoped=true", function () {
      api.rerender('0507b262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/union/UnionNode.vue"
export default component.exports